export default "__VITE_ASSET__CJktBDzr__"